(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[12],{

/***/ "01Ne":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__("48Ti");

/**
 * Decode the id to get the version and worker
 * Mainly for debugging and testing.
 * @param id - the shortid-generated id.
 */
function decode(id) {
    var characters = alphabet.shuffled();
    return {
        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
    };
}

module.exports = decode;


/***/ }),

/***/ "48Ti":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__("w9cF");

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

module.exports = {
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),

/***/ "58k+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

function randomByte() {
    if (!crypto || !crypto.getRandomValues) {
        return Math.floor(Math.random() * 256) & 0x30;
    }
    var dest = new Uint8Array(1);
    crypto.getRandomValues(dest);
    return dest[0] & 0x30;
}

module.exports = randomByte;


/***/ }),

/***/ "5xkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINK_SPACINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TITLE_POSITIONS; });
/* unused harmony export SIZES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getHeroDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateBackgroundStylesAndClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getBackgroundImageUrl; });
/* unused harmony export getBackgroundRule */
/* unused harmony export getAllBackgroundRules */
/* unused harmony export AUTO */
/* unused harmony export PREFIXES */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("FLQK");
/* harmony import */ var _navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1cDg");
/* harmony import */ var _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("lDxO");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("m1JM");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var AUTO = '_AUTOFORMAT_';
var PREFIXES = ['webkit', 'moz', 'o', 'ms'];

var getBackgroundImageUrl = function getBackgroundImageUrl(url, width) {
  var options = {
    format: AUTO,
    url: url,
    width: width,
    height: 'auto',
    transform: 'resize',
    quality: 70
  };
  return _utils_media_server__WEBPACK_IMPORTED_MODULE_1__[/* getUrl */ "a"](options);
};

var getBackgroundRule = function getBackgroundRule(params) {
  return function (getUrlFunction) {
    return function (prefixes) {
      var id = params.id,
          url = params.url,
          width1x = params.width1x,
          width2x = params.width2x;
      return ".".concat(id, " {\n        background-image:url(").concat(getUrlFunction(url, width1x), ");\n        ").concat(prefixes.reduce(function (acc, prefix) {
        return "".concat(acc, "\n        background-image: -").concat(prefix, "-image-set(url(").concat(getUrlFunction(url, width1x), ") 1x, url(").concat(getUrlFunction(url, width2x), ") 2x);\n        ");
      }, ''), "\n      }");
    };
  };
};

var getAllBackgroundRules = function getAllBackgroundRules(params) {
  return function (getRuleFunction) {
    return "".concat(getRuleFunction(params)(getBackgroundImageUrl)(PREFIXES));
  };
};

var ICON_POSITIONS = {
  'top-left': 'items-start justify-start',
  'top-middle': 'items-start justify-center',
  'top-right': 'items-start justify-end',
  'center-left': 'items-center justify-start',
  'center-middle': 'items-center justify-center',
  'center-right': 'items-center justify-end',
  'bottom-left': 'items-end justify-start',
  'bottom-middle': 'items-end justify-center',
  'bottom-right': 'items-end justify-end'
};
var LINK_SPACINGS = {
  left: 'md:p-px30 md:rtl:-ml-px30',
  center: 'md:p-px30',
  right: 'md:p-px30 md:rtl:-mr-px30'
};
var TITLE_POSITIONS = {
  'top-left': 'mb-auto items-start rtl:text-left',
  'top-middle': 'mb-auto items-center text-center',
  'top-right': 'mb-auto items-end rtl:text-right',
  'center-left': 'my-auto items-start rtl:text-left',
  'center-middle': 'my-auto items-center text-center',
  'center-right': 'my-auto items-end rtl:text-right',
  'bottom-left': 'mt-auto items-start rtl:text-left',
  'bottom-middle': 'mt-auto items-center text-center',
  'bottom-right': 'mt-auto items-end rtl:text-right'
};
var SIZES = {
  small: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  highlightSmall: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  medium: {
    mobile: {
      height: '320px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '440px',
      paddingBottom: '100px'
    }
  },
  large: {
    mobile: {
      height: '420px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '540px',
      paddingBottom: '115px'
    }
  },
  highlight: {
    mobile: {
      height: '480px',
      paddingBottom: '40px'
    },
    desktop: {
      height: '480px',
      paddingBottom: '70px'
    }
  },
  full: {
    mobile: {
      height: '100%',
      paddingBottom: '60px'
    },
    desktop: {
      height: '100%',
      paddingBottom: '115px'
    }
  }
};
var getHeroDimensions = function getHeroDimensions(sizeProp, isDesktop) {
  var size = SIZES[sizeProp] ? SIZES[sizeProp] : SIZES.large;
  var isHighlight = sizeProp === 'highlightSmall' || sizeProp === 'highlight';
  var heroPaddingTop = isDesktop ? _navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_2__[/* heights */ "e"].NAVIGATION_LARGE_HEIGHT : _navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_2__[/* heights */ "e"].NAVIGATION_NARROW_HEIGHT;
  var highlightPaddingTop = isDesktop ? '80px' : '40px';
  return {
    height: isDesktop ? size.desktop.height : size.mobile.height,
    paddingBottom: isDesktop ? size.desktop.paddingBottom : size.mobile.paddingBottom,
    paddingTop: isHighlight ? highlightPaddingTop : heroPaddingTop
  };
};
var generateBackgroundStylesAndClassName = function generateBackgroundStylesAndClassName(url) {
  if (!url) {
    return {
      style: '',
      className: ''
    };
  }

  var componentId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_4__[/* generateUniqueId */ "b"])([url]);
  var widths = _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_3__[/* defaultDictionnary */ "a"].getWidthRanges();
  var params = {
    id: componentId,
    url: url
  };
  return {
    className: componentId,
    style: "".concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[1],
      width2x: widths[2]
    }))(getBackgroundRule), "\n      @media all and (min-width: 22.51em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[2],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 40.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[3],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 64.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[5],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 76.26em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[6],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }")
  };
};


/***/ }),

/***/ "FZlW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomByte = __webpack_require__("58k+");

function encode(lookup, number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = encode;


/***/ }),

/***/ "G8Pb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__("48Ti");
var encode = __webpack_require__("FZlW");
var decode = __webpack_require__("01Ne");
var build = __webpack_require__("tDlq");
var isValid = __webpack_require__("gM+Z");

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__("cHLG") || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.decode = decode;
module.exports.isValid = isValid;


/***/ }),

/***/ "MIfU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__("G8Pb");


/***/ }),

/***/ "cHLG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),

/***/ "gM+Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__("48Ti");

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var characters = alphabet.characters();
    var len = id.length;
    for(var i = 0; i < len;i++) {
        if (characters.indexOf(id[i]) === -1) {
            return false;
        }
    }
    return true;
}

module.exports = isShortId;


/***/ }),

/***/ "m1JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateUniqueId; });
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("MIfU");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(shortid__WEBPACK_IMPORTED_MODULE_0__);

var cleanupId = function cleanupId(text) {
  return text ? "".concat(text).replace(/[^a-zA-Z0-9]/g, '').toLocaleLowerCase() : '';
};
var generateUniqueId = function generateUniqueId(list) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (list.length) {
    var id = list.filter(Boolean).map(cleanupId).filter(Boolean).join('-');

    if (id) {
      return "".concat(prefix).concat(id).toLocaleLowerCase();
    }
  } // should not occurs, it breaks the server/client reconciliation


  return "".concat(prefix).concat(shortid__WEBPACK_IMPORTED_MODULE_0___default.a.generate()).toLocaleLowerCase();
};

/***/ }),

/***/ "mmhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Countdown_Countdown; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.themes.js




var defaultValueSizes = {
  small: {
    w: '2.3rem',
    valueTextSize: 'text-md',
    labelTextSize: 'text-xxs'
  },
  large: {
    w: '3.0625rem',
    valueTextSize: 'text-2xl',
    labelTextSize: 'text-xs'
  }
};
var themes = {
  "default": Object(lodash["memoize"])(function (_ref) {
    var size = _ref.size,
        color = _ref.color;
    var textColor = color ? color : colors["a" /* COLORS */].WHITE;
    var textShadow = textColor === colors["a" /* COLORS */].WHITE ? 'text-shadow-2' : '';
    return {
      thRoot: 'flex rtl:flex-row items-stretch',
      thItem: "flex flex-col items-center justify-between mx-px5 text-center text-".concat(textColor),
      thValuesWrapper: 'flex flex-row',
      thLabel: "font-bold leading-one mb-px5 ".concat(textShadow, " uppercase ").concat(defaultValueSizes[size].labelTextSize),
      thValue: "flex font-bold items-center justify-center rounded-small text-center ".concat(textShadow, " leading-tight ").concat(defaultValueSizes[size].valueTextSize),
      thValueStyle: {
        width: defaultValueSizes[size].w
      }
    };
  }),
  timer: Object(lodash["memoize"])(function (_ref2) {
    var size = _ref2.size,
        color = _ref2.color;
    return {
      thRoot: 'flex items-stretch justify-center text-base mb-px15',
      thDescription: "bg-".concat(color, " text-white shadow-sm py-px5 px-px10 mr-px10 items-baseline"),
      thItem: "flex flex-row items-center justify-between text-center text-".concat(color),
      thLabel: 'items-baseline',
      thValuesWrapper: 'flex flex-row shadow-sm py-px5 px-px10 w-30 justify-center',
      thValue: 'flex items-center justify-center rounded-small text-center pl-px5',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  }),
  offerPush: function offerPush(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref3$color,
        bgColor = _ref3.bgColor;
    return {
      thRoot: classnames_default()("font-brand px-px5 rounded-tiny text-".concat(color), Object(defineProperty["a" /* default */])({}, "bg-".concat(bgColor), !!bgColor)),
      thItem: "inline mx-px text-center text-".concat(color, " text-xs uppercase"),
      thValuesWrapper: 'flex flex-row',
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: 'auto'
      }
    };
  },
  infoBanner: function infoBanner() {
    return {
      thRoot: 'font-brand px-px5 rounded-tiny',
      thItem: 'flex mx-px text-center text-base uppercase',
      thValuesWrapper: 'flex flex-row',
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: '20px'
      }
    };
  },
  push: Object(lodash["memoize"])(function (_ref4) {
    var color = _ref4.color;
    return {
      thRoot: "font-brand text-".concat(color, " text-lg uppercase"),
      thValuesWrapper: 'flex',
      thItem: 'flex items-center leading-one mx-px2'
    };
  }),
  options: Object(lodash["memoize"])(function (_ref5) {
    var size = _ref5.size,
        color = _ref5.color;
    return {
      thRoot: 'flex rtl:flex-row items-stretch mb-px5',
      thDescription: 'font-bold text-blue py-px5 items-baseline',
      thItem: "flex flex-row items-baseline justify-between text-center text-".concat(color),
      thLabel: 'items-baseline text-base',
      thValuesWrapper: 'flex flex-row font-bold text-lg items-center',
      thValue: 'flex items-center justify-center rounded-small text-center pl-px5 text-lg',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  }),
  optionDetails: Object(lodash["memoize"])(function (_ref6) {
    var size = _ref6.size,
        color = _ref6.color;
    return {
      thRoot: 'flex rtl:flex-row items-stretch',
      thDescription: 'font-bold text-blue py-px5 items-baseline',
      thItem: "flex flex-col items-center text-".concat(color, " bg-gray-lighter p-px5 ml-px5"),
      thLabel: 'items-baseline text-xs text-gray-darker',
      thValuesWrapper: 'flex flex-row font-bold text-lg items-center',
      thValue: 'flex items-center justify-center rounded-small text-center pl-px5 text-lg',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  })
};
// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx

var __jsx = react_default.a.createElement;





function calculateTimeLeft(dateTimeEnd) {
  var now = moment_default()();
  return now.isBefore(dateTimeEnd) ? moment_default.a.duration(moment_default()(dateTimeEnd).diff(now)) : moment_default.a.duration(0);
}

function resolveTime(unit, roundToUnit, timeRemaining) {
  if (roundToUnit === unit) {
    switch (roundToUnit) {
      case 'days':
        return Math.floor(timeRemaining.asDays()).toString();

      case 'hours':
        return Math.floor(timeRemaining.asHours()).toString();

      case 'minutes':
        return Math.floor(timeRemaining.asMinutes()).toString();

      case 'seconds':
        return Math.floor(timeRemaining.asSeconds()).toString();

      default:
        return Math.floor(timeRemaining.asSeconds()).toString();
    }
  }

  return timeRemaining.get(unit).toString();
}

var Countdown_Countdown = function Countdown(_ref) {
  var bgColor = _ref.bgColor,
      className = _ref.className,
      color = _ref.color,
      dataTestId = _ref.dataTestId,
      dateTimeEnd = _ref.dateTimeEnd,
      description = _ref.description,
      expiredRender = _ref.expiredRender,
      _ref$roundToUnit = _ref.roundToUnit,
      roundToUnit = _ref$roundToUnit === void 0 ? 'days' : _ref$roundToUnit,
      _ref$showTimer = _ref.showTimer,
      showTimer = _ref$showTimer === void 0 ? true : _ref$showTimer,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$units = _ref.units,
      units = _ref$units === void 0 ? ['days', 'hours', 'minutes', 'seconds'] : _ref$units,
      _ref$updateFrequency = _ref.updateFrequency,
      updateFrequency = _ref$updateFrequency === void 0 ? 300 : _ref$updateFrequency,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["bgColor", "className", "color", "dataTestId", "dateTimeEnd", "description", "expiredRender", "roundToUnit", "showTimer", "size", "theme", "units", "updateFrequency"]);

  var _useState = Object(react["useState"])(calculateTimeLeft(dateTimeEnd)),
      timeRemaining = _useState[0],
      setTimeRemaining = _useState[1];

  Object(react["useEffect"])(function () {
    var timer = setTimeout(function () {
      if (dateTimeEnd && timeRemaining.asSeconds() > 0) {
        setTimeRemaining(calculateTimeLeft(dateTimeEnd));
      }
    }, updateFrequency);
    return function () {
      return clearTimeout(timer);
    };
  }, [timeRemaining, dateTimeEnd]);

  var shouldDisplay = function shouldDisplay() {
    return timeRemaining.asSeconds() > 0 && timeRemaining.months() === 0;
  };

  if (!shouldDisplay()) {
    if (dateTimeEnd && !!expiredRender) {
      return expiredRender;
    }

    return null;
  }

  if (!showTimer) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color,
    size: size,
    bgColor: bgColor
  }),
      thItem = _themes$theme.thItem,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thValue = _themes$theme.thValue,
      thDescription = _themes$theme.thDescription,
      thValueStyle = _themes$theme.thValueStyle,
      thValuesWrapper = _themes$theme.thValuesWrapper;

  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    role: "timer",
    "data-testid": dataTestId
  }, description && __jsx("div", {
    className: thDescription
  }, description), __jsx("div", {
    className: thValuesWrapper
  }, units.map(function (unit) {
    var currentTime = resolveTime(unit, roundToUnit, timeRemaining);
    var transformedCurrentTime = currentTime.padStart(2, '0');
    return __jsx("div", {
      className: thItem,
      key: unit
    }, __jsx("div", {
      className: thValue,
      style: thValueStyle
    }, transformedCurrentTime), __jsx("div", {
      className: thLabel
    }, " ", props[unit]));
  })));
};

/***/ }),

/***/ "tDlq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__("FZlW");
var alphabet = __webpack_require__("48Ti");

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {

    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + encode(alphabet.lookup, version);
    str = str + encode(alphabet.lookup, clusterWorkerId);
    if (counter > 0) {
        str = str + encode(alphabet.lookup, counter);
    }
    str = str + encode(alphabet.lookup, seconds);

    return str;
}

module.exports = build;


/***/ }),

/***/ "w9cF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ })

}]);